module.exports = __webpack_public_path__ + "Flag-422.b3ae1fba15ce1be4c1f370a9920bb9ba.svg";